import { render } from "./RelatorioFluxoFinanceiroIndex.vue?vue&type=template&id=03c88597&scoped=true&ts=true"
import script from "./RelatorioFluxoFinanceiroIndex.vue?vue&type=script&lang=ts"
export * from "./RelatorioFluxoFinanceiroIndex.vue?vue&type=script&lang=ts"

import "./RelatorioFluxoFinanceiroIndex.vue?vue&type=style&index=0&id=03c88597&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c88597"]])

export default __exports__